const gdpr = typeof window === 'undefined' ? {} : window.__is_gdpr_user__

const GDPR_DEFAULTS = {
  advertising: false,
  analytics: false,
  functionality: false,
  performance: false,
  initial: true // This indicates that the user has not interacted with our consent modal and saved their preferences yet
}

const OTHER_DEFAULTS = {
  advertising: true,
  analytics: true,
  functionality: true,
  performance: true,
  initial: true // This indicates that the user has not interacted with our consent modal and saved their preferences yet
}

function writeCookie(preferences) {
  // Setting max-age to 1 year in seconds
  const maxAge = 365 * 24 * 60 * 60
  document.cookie = 'fa_cookie_settings=' + JSON.stringify(preferences) + '; max-age=' + maxAge + '; path=/; SameSite=Strict'
}

function getPreferences() {
  if (typeof document === 'undefined') {
    return GDPR_DEFAULTS
  }

  const cookieValue = document.cookie.match('(^|;)\\s*' + 'fa_cookie_settings' + '\\s*=\\s*([^;]+)')

  if (cookieValue) {
    return JSON.parse(cookieValue.pop())
  }

  if (gdpr) {
    writeCookie(GDPR_DEFAULTS)
    return GDPR_DEFAULTS
  } else {
    writeCookie(OTHER_DEFAULTS)
    return OTHER_DEFAULTS
  }
}

export function getAdvertisingPreferences() {
  const value = getPreferences()
  return value !== null ? value.advertising : !gdpr
}

export function getAnalyticsPreferences() {
  const value = getPreferences()
  return value !== null ? value.analytics : !gdpr
}

export function getFunctionalityPreferences() {
  const value = getPreferences()
  return value !== null ? value.functionality : !gdpr
}

export default {
  namespaced: true,

  // Let's talk about "isShowingManagement". It's a little unusual to see a UI
  // state property in a Vuex store. But we're able to trigger the UI for
  // cookie preferences from the footer of the page. Since the UI is a
  // modal-like thing, we need a way to show it without a variable being tied
  // to the component that triggers the action.
  state: {
    preferences: getPreferences(),
    isShowingManagement: false // Should the UI for changing cookie preferences be shown?
  },

  mutations: {
    preferences(state, { preferences }) {
      preferences.initial = false
      writeCookie(preferences)
      state.preferences = preferences
    },

    manage(state, value) {
      state.isShowingManagement = value
    },

    resetState(state) {
      // We intentionally do not reset the state for the cookie preferences.
      // They exist outside the normal purview of the "resetState" use case.
      //
      // For more context regarding this check out store/moduls/sessions.js and
      // the removeSession() function.
    }
  },

  getters: {
    isGdprUser(state) {
      return gdpr
    },

    isShowingManagement(state) {
      return state.isShowingManagement
    },

    preferences(state) {
      return state.preferences
    },

    noPreferencesAndGdpr(state) {
      return state.preferences.initial && gdpr
    }
  },

  actions: {
    setPreferences({ commit }, { preferences }) {
      commit('preferences', { preferences })
      commit('manage', false)
    },

    manageCookiePreferences({ commit }) {
      commit('manage', true)
    },

    hideCookiePreferences({ commit }) {
      commit('manage', false)
    }
  }
}
